export default {
  bookExperiencePanel: 'แผงจองประสบการณ์',
  calendarIcon: 'ไอคอนปฏิทิน',
  coverImageForResource: 'ภาพปกสำหรับประสบการณ์ {{title}}',
  filterBy: 'กรองตาม {{filter}}',
  filterByDateRange: 'กรองตามช่วงวันที่',
  gallery: 'แกลเลอรี',
  goBack: 'กลับไปหน้าก่อนหน้า',
  hostUserIcon: 'ไอคอนผู้จัดกิจกรรม',
  imageOf: 'รูปภาพของ {{title}}',
  interactiveMapAltText: 'แผนที่โต้ตอบที่สามารถเลือก {{title}} ได้',
  mediaSlides: 'สไลด์สื่อ',
  muteVideo: 'ปิดเสียงวิดีโอ',
  nextPhoto: 'รูปถัดไป',
  noVideoPlayback: 'ไม่สามารถเล่นวิดีโอได้',
  pauseVideo: 'หยุดวิดีโอชั่วคราว',
  photoOf: 'รูปภาพของ {{name}}',
  playVideo: 'เล่นวิดีโอ',
  previousPhoto: 'รูปก่อนหน้า',
  moreFiltersAndExperiences: 'ตัวกรองและประสบการณ์เพิ่มเติม',
  reserveSelectedSlot: 'จองช่วงเวลาที่เลือก',
  reviewRating: 'คะแนนรีวิว {{rating}} จาก 5',
  overallReviewRating: 'คะแนนรีวิวโดยรวม {{rating}} จาก 5',
  selectCountryCodeForPhoneNumber: 'เลือกรหัสประเทศสำหรับหมายเลขโทรศัพท์',
  selectDate: 'เลือกวันที่',
  selectParticipants: 'เลือกผู้เข้าร่วม',
  selectSessionTime: 'เลือกเวลาของรอบ',
  unmuteVideo: 'เปิดเสียงวิดีโอ',
  viewShoppingCart: 'ดูตะกร้าสินค้า',
  itemsInCart: '{{count}} รายการในตะกร้าสินค้า',
  zoomIn: 'ซูมเข้า',
  zoomOut: 'ซูมออก',
  selectData: `เลือก {{data}}`,
  reserveName: `จอง {{name}}`,
  deleteReservation: 'ลบการจอง {{experienceTitle}}',
  editParticipantsFor: 'แก้ไขผู้เข้าร่วมสำหรับ {{experienceTitle}}',
  enterPromoCode: 'ใส่รหัสโปรโมชัน',
  applyPromoCode: 'ใช้รหัสโปรโมชัน',
  increaseAddOnAmount: 'เพิ่มจำนวน {{addOn}} ที่เลือก',
  decreaseAddOnAmount: 'ลดจำนวน {{addOn}} ที่เลือก',
  addOnModal: '{{addOn}} โมดัล',
  moreInformationAboutAddOn: 'ข้อมูลเพิ่มเติมเกี่ยวกับ {{addOn}}',
  decreasePriceTierTickets: 'ลดจำนวนตั๋ว {{priceTier}}',
  increasePriceTierTickets: 'เพิ่มจำนวนตั๋ว {{priceTier}}',
  downloadFilename: 'ดาวน์โหลด {{filename}}',
  viewFullDetailsDescription: 'ดูรายละเอียดทั้งหมด',
  viewFullDescription: 'ดูคำอธิบายทั้งหมด',
  closeModal: 'ปิดโมดัล',
  hyattBanner: 'แบนเนอร์สิทธิพิเศษสำหรับสมาชิก World Of Hyatt',
  hyattBannerDesc:
    'แบนเนอร์โปรโมชันที่แสดงสิทธิประโยชน์และข้อเสนอพิเศษสำหรับสมาชิกโปรแกรมสะสมคะแนน World of Hyatt',
  previousSlide: 'สไลด์ก่อนหน้า',
  nextSlide: 'สไลด์ถัดไป',
  paginationBulletMessage: 'ไปยังสไลด์',
  exitFullscreen: 'ออกจากมุมมองเต็มหน้าจอ',
  enterFullscreen: 'เข้าสู่มุมมองเต็มหน้าจอ',
  videoSlide: 'สไลด์วิดีโอ',
  imageSlide: 'สไลด์รูปภาพ',
  of: 'จาก',
  noDescription: 'ไม่มีคำอธิบาย',
  mediaGallery: 'ภาพหมุน - แกลเลอรีสื่อ',
  dateSelector: 'ตัวเลือกวันที่',
  nextWeek: 'สัปดาห์ถัดไป',
  previousWeek: 'สัปดาห์ก่อน',
  scheduleAgenda: 'วาระตารางเวลา',
  scheduleNav: 'การนำทางตารางเวลา',
  scheduleViewSelector: 'ตัวเลือกมุมมองตารางเวลา',
  selectedDateAriaLabel: '{{date}}, เลือกแล้ว',
  tapToBookExperience: 'จอง {{title}}',
  bookExperienceAriaLabel: 'จอง {{title}}',
  joinWaitlistAriaLabel: 'เข้าร่วมรายชื่อรอสำหรับ {{title}}',
};
